<template>
	<div class="pagination-container">
		<div class="row left-side">
			<AppSelect :selected-index="selectIndexFromInitialPageSize" :values="sizes" @selected="changePageSize"  />
			<p>{{ getString('total_pagination', [totalDisplay]) }}</p>
		</div>
		<div class="row right-side">
			<div class="page-buttons">
				<div ref="page-button-1" class="page-button" :class="{active: pageButton1 === page+1}" v-if="!!pageButton1" @click="clickPageButton(1)">{{ pageButton1 }}</div>
				<div ref="page-button-2" class="page-button" :class="{active: pageButton2 === page+1}" v-if="!!pageButton2" @click="clickPageButton(2)">{{ pageButton2 }}</div>
				<div ref="page-button-3" class="page-button" :class="{active: pageButton3 === page+1}" v-if="!!pageButton3" @click="clickPageButton(3)">{{ pageButton3 }}</div>
				<div ref="page-button-4" class="page-button" :class="{active: pageButton4 === page+1}" v-if="!!pageButton4" @click="clickPageButton(4)">{{ pageButton4 }}</div>
				<div ref="page-button-5" class="page-button" :class="{active: pageButton5 === page+1}" v-if="!!pageButton5" @click="clickPageButton(5)">{{ pageButton5 }}</div>
				<div ref="page-button-6" class="page-button" :class="{active: pageButton6 === page+1}" v-if="!!pageButton6" @click="clickPageButton(6)">{{ pageButton6 }}</div>
				<div ref="page-button-7" class="page-button" :class="{active: pageButton7 === page+1}" v-if="!!pageButton7" @click="clickPageButton(7)">{{ pageButton7 }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import AppSelect from "@/shared/components/AppSelect.vue";
import {useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		let languageStore = useLanguageStore();
		return {getString: languageStore.getString}
	},
	name: "PaginationRow",
	components: {AppSelect},
	emits: ['page-changed'],
	props: {
		page: {
			type: Number,
			default: 0
		},
		pageSize: {
			type: Number,
			default: 10
		},
		initialPageSize: {
			type: Number,
			default: 10
		},
		total: {
			type: Number,
			default: 0
		},
		pageSizeOptions: {
			type: Array,
			default: null
		}
	},
	computed: {
		sizes() {
			return this.pageSizeOptions || ['10', '25', '50', '100'];
		},
		totalDisplay() {
			if (this.total > 999) {
				return "999+";
			} else {
				return this.total;
			}
		},
		selectIndexFromInitialPageSize() {
			return this.sizes.indexOf(this.initialPageSize.toString());
		},
		numPages() {
			return Math.ceil(this.total / this.pageSize);
		},
		pageButton1() {
			if (this.numPages === 0) {
				return null;
			}
			return 1;
		},
		pageButton2() {
			if (this.numPages <= 1) {
				return null;
			} else if(this.numPages <= 7) {
				return 2;
			} else {
				if(this.page <= 3) {
					return 2;
				} else {
					return "...";
				}
			}
		},
		pageButton3() {
			if (this.numPages <= 2) {
				return null;
			} else if(this.numPages <= 7) {
				return 3;
			} else {
				if(this.page <= 3) {
					return 3;
				} else if(this.page >= this.numPages - 3) {
					return this.numPages - 4;
				} else {
					return this.page;
				}
			}
		},
		pageButton4() {
			if (this.numPages <= 3) {
				return null;
			} else if(this.numPages <= 7) {
				return 4;
			} else {
				if(this.page <= 3) {
					return 4;
				} else if(this.page >= this.numPages - 3) {
					return this.numPages - 3;
				} else {
					return this.page + 1;
				}
			}
		},
		pageButton5() {
			if (this.numPages <= 4) {
				return null;
			} else if(this.numPages <= 7) {
				return 5;
			} else {
				if(this.page <= 3) {
					return 5;
				} else if(this.page >= this.numPages - 3) {
					return this.numPages - 2;
				} else {
					return this.page + 2;
				}
			}
		},
		pageButton6() {
			if (this.numPages <= 5) {
				return null;
			} else if(this.numPages <= 7) {
				return 6;
			} else {
				if(this.page >= this.numPages - 3) {
					return this.numPages - 1;
				} else {
					return "...";
				}
			}
		},
		pageButton7() {
			if (this.numPages <= 6) {
				return null;
			} else if(this.numPages <= 7) {
				return 7;
			} else {
				return this.numPages;
			}
		},
	},
	methods: {
		clickPageButton(index) {

			let pageResult = this.page;

			if(index === 1) {
				if(this.pageButton1 !== null) {
					pageResult = this.pageButton1 - 1;
				}
			} else if(index === 2) {
				if(this.pageButton2 !== null) {
					if(this.numPages <= 7) {
						pageResult = 1;
					} else {
						if(this.page <= 2) {
							pageResult = 1;
						} else {
							pageResult = Math.round((this.page - 1)/2);
						}
					}
				}
			} else if(index === 3) {
				if(this.pageButton3 !== null) {
					if(this.numPages <= 7) {
						pageResult = 2;
					} else {
						if(this.page <= 2) {
							pageResult = 2;
						} else if(this.page >= this.numPages - 3) {
							pageResult = this.numPages - 5;
						} else {
							pageResult = this.page - 1;
						}
					}
				}
			} else if(index === 4) {
				if(this.pageButton4 !== null) {
					if(this.numPages <= 7) {
						pageResult = 3;
					} else {
						if(this.page <= 2) {
							pageResult = 3;
						} else if(this.page >= this.numPages - 3) {
							pageResult = this.numPages - 4;
						}
					}
				}
			} else if(index === 5) {
				if(this.pageButton5 !== null) {
					if(this.numPages <= 7) {
						pageResult = 4;
					} else {
						if(this.page <= 2) {
							pageResult = 4;
						} else if(this.page >= this.numPages - 3) {
							pageResult = this.numPages - 3;
						} else {
							pageResult = this.page + 1;
						}
					}
				}
			} else if(index === 6) {
				if(this.pageButton6 !== null) {
					if(this.numPages <= 7) {
						pageResult = 5;
					} else {
						if(this.page >= this.numPages - 3) {
							pageResult = this.numPages - 2;
						} else {
							pageResult = Math.round((this.page + 1 + this.numPages)/2);
						}
					}
				}
			} else if(index === 7) {
				if(this.pageButton7 !== null) {
					pageResult = this.pageButton7 - 1;
				}
			}

			this.$emit('page-changed', pageResult, this.pageSize);

		},
		changePageSize(i, v) {
			this.$emit('page-changed', 0, Number(v));
		}
	}
}
</script>

<style lang="scss" scoped>

.pagination-container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;

	.left-side, .right-side {
		display: flex;
		align-items: center;
		width: auto;
	}

	.left-side {
		justify-content: flex-start;

		p {
			padding-left: 10px;
			font-size: 12px;
			max-width: 100px;
		}
	}

	.right-side {
		justify-content: flex-end;
		margin-left: auto;
	}

	.page-buttons {
		display: flex;
		align-items: center;
	}

	.page-button {
		user-select: none;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		min-width: 20px;
		padding: 3px;
		margin-left: 4px;
		position: relative;
		font-size: 12px;
		line-height: 14px;
		transition: transform 0.2s ease-in-out;

		&:hover {
			transform: scale(1.05);
			transition: transform .2s ease;
		}
		&:active {
			transform: scale(0.99);
			transition: transform .08s ease;
		}

		&:before,
		&:after {
			content: "";
			position: absolute;
			left: 0;
			bottom: 0;
			right: 0;
			height: 3px;
			border-radius: 2.5px;
			background-color: var(--color-bg-primary-4);
			transform: translateX(-100%);
			transition: transform 0.3s ease-in-out, width 0.3s ease-in-out, opacity 0.3s ease-in;
		}

		&:before, &:after {
			z-index: -1;
			width: 0;
			opacity: 0;
		}

		&:after {
			z-index: 1;
		}

		&:hover:before,
		&:hover:after {
			transform: translateX(0);
			width: 100%;
			opacity: 1;
		}

		&:active:before,
		&:active:after {
			transform: translateX(100%);
			width: 0;
			opacity: 0;
		}

		&:hover:not(:active):before {
			width: 50%;
			opacity: 0.5;
		}

		&.active:before, &.active:hover:before, &.active:active:before {
			width: 100%;
			transform: translateX(0);
			opacity: 1;
			z-index: unset;
		}
		&.active:after, &.active:hover:after, &.active:active:after {
			visibility: hidden;
		}

	}

	.select-wrapper {
		max-width: 70px;
		min-width: 70px;

		:deep(.select-title) {
			height: 32px;
		}
	}

}

</style>